import Vue from "vue";
import VueRouter from "vue-router";
import Orders from "@/views/Orders/Index.vue";
import Login from "@/views/Auth/Login.vue";
import PageNotFound from "@/views/PageNotFound.vue";
import auth from "@/utils/auth";
import UI from "@/views/UI.vue"

Vue.use(VueRouter);

const routes = [
  { path: "*", name: "NotFound", component: PageNotFound },
  {
    path: "/",
    name: "Index",
    component: Orders,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      layout: "auth-layout",
      allowAnonymous: true,
    },
  },
  {
    path: "/UI",
    name: 'UI',
    component: UI,
    meta: {
      layout: "auth-layout",
      allowAnonymous: true,
    }
  },

  // Заявки ------------------------------------
  {
    path: "/orders",
    name: "Orders",
    component: Orders,
  },
  {
    path: "/orders/tickets-info/:id",
    name: "TicketsInfo",
    component: () => import("@/views/Orders/TicketsInfo.vue"),
    meta: {
      breadcrumb: {
        to: "",
      },
    },
  },
  {
    path: "/order/:type",
    name: "OrderForm",
    component: () => import("@/views/Orders/Type.vue"),
    meta: {
      breadcrumb: {
        to: "/orders",
      },
    },
    props: true,
    children: [
      {
        path: ":id",
        component: () => import("@/views/Orders/Type.vue"),
        meta: {
          breadcrumb: {
            to: "/orders",
          },
        },
        props: true
      },
    ],
  },

  // Админ панель ------------------------------------
  {
    path: "/admin-panel",
    name: "AdminPanel",
    component: () => import("@/views/AdminPanel/Index.vue"),
    meta: {},
    children: [
      {
        path: "departments",
        name: "Departments",
        component: () => import("@/views/AdminPanel/DepartmentsTree/Index.vue"),
      },
      {
        path: "passengers",
        name: "Passengers",
        component: () => import("@/views/AdminPanel/Passengers/Index.vue"),
      },
      {
        path: "filiations",
        name: "Filiations",
        component: () => import("@/views/AdminPanel/FiliationsTree/Index.vue"),
        children: [],
      },
      {
        path: "contracts",
        name: "Contracts",
        component: () => import("@/views/AdminPanel/Contracts/Index.vue"),
      },
      {
        path: "cards",
        name: "Cards",
        component: () => import("@/views/AdminPanel/Cards/Index.vue"),
      },
      {
        path: "users",
        name: "Users",
        component: () => import("@/views/AdminPanel/Users/Index.vue"),
      },
      {
        path: "admins",
        name: "Admins",
        component: () => import("@/views/AdminPanel/Admins/Index.vue"),
      },
      {
        path: "logisticians",
        name: "Logisticians",
        component: () => import("@/views/AdminPanel/Logisticians/Index.vue"),
      },
      {
        path: "osr-staff",
        name: "Osr",
        component: () => import("@/views/AdminPanel/Osr/Index.vue"),
      },
      {
        path: "return-reasons",
        name: "ReturnReasons",
        component: () => import("@/views/AdminPanel/ReturnReasons/Index.vue"),
      }
    ],
  },

  // Создание подразделения --------------------------
  {
    path: "/admin-panel/save/department/create",
    name: "SaveDepartmentCreate",
    component: () =>
      import("@/views/AdminPanel/DepartmentsTree/SaveDepartment.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/departments",
      },
    },
    props: { action: 'create' }
  },
  {
    path: "/admin-panel/save/department/:id_department/update",
    name: "SaveDepartmentUpdate",
    component: () =>
      import("@/views/AdminPanel/DepartmentsTree/SaveDepartment.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/departments",
      },
    },
    props: { action: 'update' }
  },

  // Создание филиала --------------------------
  {
    path: "/admin-panel/save/filiation/create",
    name: "SaveFiliationCreate",
    component: () =>
        import("@/views/AdminPanel/FiliationsTree/SaveFiliation.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/filiations",
      },
    },
    props: { action: 'create' }
  },
  {
    path: "/admin-panel/save/filiation/:id_filiation/update",
    name: "SaveFiliationUpdate",
    component: () =>
        import("@/views/AdminPanel/FiliationsTree/SaveFiliation.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/filiations",
      },
    },
    props: { action: 'update' }
  },

  // Пассажиры ------------------------------------
  {
    path: "/admin-panel/save/passengers",
    name: "SavePassenger",
    component: () => import("@/views/AdminPanel/Passengers/SavePassenger.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/passengers",
      },
    },
  },
  {
    path: "/admin-panel/profile/passengers/:id",
    name: "Passenger",
    component: () => import("@/views/AdminPanel/Passengers/_id.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/passengers",
      },
    },
  },

  // Пользователи ------------------------------------
  {
    path: "/admin-panel/save/:type",
    name: "SaveUser",
    component: () => import("@/views/AdminPanel/Users/SaveUser.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/users",
      },
    },
  },
  {
    path: "/admin-panel/profile/:type/:id",
    name: "User",
    component: () => import("@/views/AdminPanel/Users/_id.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/users",
      },
    },
  },

  // Договоры ----------------------------
  {
    path: "/admin-panel/save/contracts/create",
    name: "SaveContractCreate",
    component: () => import("@/views/AdminPanel/Contracts/SaveContract.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/contracts",
      },
    },
    props: { action: 'create' }
  },
  {
    path: "/admin-panel/save/contracts/:id_contract/update",
    name: "SaveContractUpdate",
    component: () => import("@/views/AdminPanel/Contracts/SaveContract.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/contracts",
      },
    },
    props: { action: 'update' }
  },


  // Карты ----------------------------
  {
    path: "/admin-panel/save/cards/create",
    name: "SaveCardCreate",
    component: () => import("@/views/AdminPanel/Cards/SaveCard.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/cards",
      },
    },
    props: { action: 'create' }
  },
  {
    path: "/admin-panel/save/cards/:id_card/update",
    name: "SaveCardUpdate",
    component: () => import("@/views/AdminPanel/Cards/SaveCard.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/cards",
      },
    },
    props: { action: 'update' }
  },

  // Причины обмена/возврата -------------
  {
    path: "/admin-panel/save/return-reasons/create",
    name: "ReturnReasonCreate",
    component: () => import("@/views/AdminPanel/ReturnReasons/ReturnReasonUpsert.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/return-reasons",
      },
    },
    props: { action: 'create' }
  },
  {
    path: "/admin-panel/save/return-reasons/:id_reason/update",
    name: "ReturnReasonUpdate",
    component: () => import("@/views/AdminPanel/ReturnReasons/ReturnReasonUpsert.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/return-reasons",
      },
    },
    props: { action: 'update' }
  },

  // Настройки
  {
    path: "/settings",
    name: "Settings",
    component: () => import("@/views/AdminPanel/Settings/Index.vue"),
    meta: {
      breadcrumb: {
        to: "/admin-panel/users",
      },
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (!to.meta.allowAnonymous && !auth.isAuthenticated()) {
    auth.unauthorizedTo = to.fullPath;
    next({ name: "Login" });
  }

  if (auth.isAuthenticated() && to.name === "Login") {
    next({ name: "Index" });
  }

  next();
});

export default router;
